class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this),
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
      this.querySelector('button.search__button')?.setAttribute(
        'disabled',
        'false',
      );
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
      this.querySelector('button.search__button')?.removeAttribute('disabled');
    }
  }

  toggleHardCodedSnippets() {
    const searchButton = this.querySelector('button.search__button');
    const hasValue = this.input?.value?.length > 0;

    if (searchButton) {
      hasValue
        ? searchButton.removeAttribute('disabled')
        : searchButton.setAttribute('disabled', 'true');
    }

    const parentElement = this.offsetParent?.offsetParent;
    if (!parentElement) return;

    const snippet = parentElement.querySelector('.overriding_snippet');
    const predictiveSearch = parentElement.querySelector(
      '.overriding_predictive_search',
    );

    if (snippet) snippet.style.display = hasValue ? 'none' : 'block';
    if (predictiveSearch)
      predictiveSearch.style.display = hasValue ? 'block' : 'none';
  }

  onChange() {
    this.toggleResetButton();
    this.toggleHardCodedSnippets();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
      this.toggleHardCodedSnippets();
    }
  }
}

customElements.define('search-form', SearchForm);
